import React from "react";
import ScheduleAwardSummaryCard from "./components/ScheduleAwardSummaryIndex.jsx";

const ScheduleAwardSummary = () => <ScheduleAwardSummaryCard />;

export default ScheduleAwardSummary;
